import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Currently application is in the maintenance.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Please try again later.", -1)

import AppStatus from '@/components/Base/AppStatus/AppStatus.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'AppMaintenance',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppStatus, { title: "Maintenance" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }))
}
}

})